import { EntidadeBase } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
class PesquisaModel extends EntidadeBase {
    constructor() {
        super('pesquisa');
    }

    async ativar(id) { return await ApiService.post('pesquisa/ativar', { id }); }
    async desativar(id) { return await ApiService.post('pesquisa/desativar', { id }); }
    async executarAgora(id) { return await ApiService.post('pesquisa/executaragora', { id }); }
}
const instance = new PesquisaModel();
export default instance;
